import { render, staticRenderFns } from "./ProductSetsV1.vue?vue&type=template&id=2e6181b5&scoped=true"
import script from "./ProductSetsV1.vue?vue&type=script&lang=js"
export * from "./ProductSetsV1.vue?vue&type=script&lang=js"
import style0 from "./ProductSetsV1.vue?vue&type=style&index=0&id=2e6181b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6181b5",
  null
  
)

export default component.exports